import React from "react";
import investorHospital from  "../../../assets/investor/investor-hospital.png";
import {Link} from "react-router-dom";

function CorporateHomeIntro() {
   return (
    <>
        <div className="investor-hospital-container">
          <img
            src={investorHospital}
            alt=""
            style={{ width: "45%" }}
          />
          <div className="content-container">
            <h2 className="who-we-are">Who We Are</h2>
            <p>At KPJ, we've honed our business model over 43 years in the Malaysian Private Healthcare Industry. Our strength lies in overseeing a network of specialised hospitals and strategic investments across diverse sectors. Our focus is on cultivating lasting value for all our stakeholders, ensuring a prosperous and sustainable future.</p>
            <Link to="https://kpj.listedcompany.com/profile.html" className="learn-more">
                Learn More{" "}
                <span>
                <img
                    src="./../img/icon/56.png"
                    alt=""
                    className="learn-more-img"
                />
                </span>
            </Link>
          </div>
        </div>
    </>
   ) 
}

export default CorporateHomeIntro;